export type {
  RecognitionStatus,
  ResultStatus,
  ImageObject,
  SerializableImageObject,
  SerializableDetectedObject,
  DetectedObject,
  ClassificationResultType,
} from './imageRecognition.d';

// Import ResultStatus for type annotation
import type { ResultStatus } from './imageRecognition.d';

// Classification result constants: 0=negative, 1=positive, 2=invalid, 3=rejected, 4=model_error
export const CLASSIFICATION_RESULT = {
  NEGATIVE: 0,
  POSITIVE: 1,
  INVALID: 2,
  REJECTED: 3,
  MODEL_ERROR: 4,
} as const;

// Map numeric result (0, 1, 2, 3, 4) to ResultStatus string
export const RESULT_STATUS_MAP: Record<number, ResultStatus> = {
  [CLASSIFICATION_RESULT.NEGATIVE]: "NEGATIVE",
  [CLASSIFICATION_RESULT.POSITIVE]: "POSITIVE",
  [CLASSIFICATION_RESULT.INVALID]: "INVALID",
  [CLASSIFICATION_RESULT.REJECTED]: "REJECTED",
  [CLASSIFICATION_RESULT.MODEL_ERROR]: "MODEL_ERROR",
};
